import { defineMessages } from 'react-intl';
// FIXME: traduzir na comunidade

export default defineMessages({
  AddTab: { defaultMessage: 'Add tab', id: 'Add tab' },
  AddBlock: { defaultMessage: 'Add block', id: 'Add block' },
  RemoveBlock: { defaultMessage: 'Remove block', id: 'Remove block' },
  Default: { defaultMessage: 'Default', id: 'Default' },
  Tab: { id: 'Tab', defaultMessage: 'Tab' },
  Tabs: { id: 'Tabs', defaultMessage: 'Tabs' },
  TabsBlock: { defaultMessage: 'Tabs block', id: 'Tabs block' },
  TabTitle: { defaultMessage: 'Tab title', id: 'Tab title' },
  TabNum: { defaultMessage: 'Tab #{index}', id: 'Tab #{index}' },
  unknownBlock: {
    id: 'Unknown Block',
    defaultMessage: 'Unknown Block {block}',
  },
  delete: { id: 'delete', defaultMessage: 'delete' },
  DragAndDrop: { id: 'Drag and drop', defaultMessage: 'Drag and drop' },
});
